
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">AI虚拟人物交流：与虚拟人物的交流</h2>
                    <div class="time">2024-03-22 11:00:10</div>
                    <div class="start">
                        在数字化时代，人工智能技术正在以前所未有的速度改变着我们的生活方式和沟通方式。近年来，随着AI技术的不断发展，AI虚拟人物逐渐成为了人们日常生活中的新伙伴。这些虚拟人物不仅具备智能和情感，还能够通过自然语言处理和多模态交流与人类进行互动。AI虚拟人物的出现，为人们带来了全新的交流体验和可能性。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/308.png" alt="AI虚拟人物交流：与虚拟人物的交流" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            随着人工智能技术的不断进步，AI虚拟人物已经成为了许多领域的重要应用。无论是在在线客服、虚拟助手、教育培训还是娱乐游戏等领域，AI虚拟人物都扮演着越来越重要的角色。通过先进的语音识别和自然语言处理技术，这些虚拟人物能够与用户进行智能对话，解答问题、提供服务，甚至进行情感交流。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            与传统的机器人交互相比，AI虚拟人物的交流更加自然和人性化。它们不仅可以模拟人类的语言和行为，还能够通过面部表情、手势动作等方式与用户进行多模态交流，增强交流的情感共鸣和亲近感。这种生动、多样化的交流方式，让人们感受到了与虚拟世界的更加紧密的联系。

                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            此外，AI虚拟人物的交流还具有个性化和定制化的特点。根据用户的偏好和需求，虚拟人物可以进行个性化定制，包括语言风格、情感表达、交流内容等方面。这种个性化交流方式能够更好地满足用户的需求，增强交流的亲和力和吸引力，提升用户体验和满意度。

                        </div>
                    </div>

                    <div class="end">
                        AI虚拟人物交流已经成为了一种新的社交和沟通方式，为人们带来了更加便捷、生动和个性化的交流体验。随着技术的不断创新和应用的拓展，相信AI虚拟人物交流将在未来发挥着越来越重要的作用，为人们的生活和工作带来更多的便利和乐趣。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "AI虚拟人物交流：与虚拟人物的交流-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "AI虚拟人物交流：与虚拟人物的交流,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "在数字化时代，人工智能技术正在以前所未有的速度改变着我们的生活方式和沟通方式",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo308.vue